import {
    convertUniversalDateTimeToPersianDateTime,
    convertUniversalDateToPersianDate, RaikoBaseCardContainer,
    RaikoCreatorInfo, RaikoDatePicker,
    RaikoGridOneColumn, RaikoGridThreeColumn, RaikoHtmlTextEditor,
    RaikoSectionContainer, RaikoSimpleInputOutlined, RaikoSimpleMultiLineInputOutlined, showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {MawakibService} from "../../../serverService/mawakibService/MawakibService";

export default function MawakibBasicInfo({mawakibId}) {


    const service = new MawakibService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [title, setTitle] = useState("")
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [description, setDescription] = useState("")
    const [createdBy, setCreatedBy] = useState("")
    const [createAt, setCreateAt] = useState("")
    const [rules, setRules] = useState("")


    useEffect(() => {
        getMawakibBasicInfoFromServer()
    }, [mawakibId]);

    function getMawakibBasicInfoFromServer() {
        loading.show()
        service.getMawakibDetailInfo(mawakibId)
            .then(response => {
                setTitle(response.title)
                setStartDate(convertUniversalDateToPersianDate(response.startDate))
                setEndDate(convertUniversalDateToPersianDate(response.endDate))
                setRules(response.rules)
                setCreateAt(convertUniversalDateTimeToPersianDateTime(response.createdAt))
                setCreatedBy(response.createdBy)
                setDescription(response.description)

            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }


    return (
        <>
            <RaikoGridOneColumn>
                <RaikoBaseCardContainer>
                    <RaikoSectionContainer title={"اطلاعات پایه"}>
                        <RaikoGridOneColumn>
                            <RaikoGridThreeColumn>
                                <RaikoSimpleInputOutlined
                                    labelText={"عنوان"}
                                    value={title}
                                    setValue={setTitle}
                                />
                                <RaikoDatePicker
                                    label={"تاریخ شروع"}
                                    date={startDate}
                                    setDate={setStartDate}
                                />
                                <RaikoDatePicker
                                    label={"تاریخ پایان"}
                                    date={endDate}
                                    setDate={setEndDate}
                                />
                            </RaikoGridThreeColumn>
                            <RaikoSimpleMultiLineInputOutlined
                                labelText={"توضیحات"}
                                setValue={setDescription}
                                multiline={true}
                                row={10}
                                value={description}
                                required
                            />
                            <RaikoHtmlTextEditor
                                text={rules}
                                setText={setRules}
                            />

                        </RaikoGridOneColumn>
                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>
                <RaikoCreatorInfo createdBy={createdBy} createdAt={createAt}/>
            </RaikoGridOneColumn>
        </>
    )
}